import RandingStyle1 from "../../randing/RandingStyle1";
// import { Helmet } from "react-helmet";

function Randing056({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/056/25010301.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/056/25010302.jpg`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/056/25010303.jpg`} // 스텝 변경되는 이미지
      numberColor="#201c54"
      qOptionColor="lightBlue"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/teal/nextStepButton.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/teal/applyButton.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing056;
